import type { FC, ComponentProps } from "react";

import createComponentPreset from "./createComponentPreset";

const createFabric =
    <T extends FC<any>>(
        displayName: string,
        Component: T,
        preparedProps?: ComponentProps<T>,
    ) =>
    (parentDisplayName: string) => {
        return createComponentPreset(
            `${parentDisplayName}.${displayName}`,
            Component,
            preparedProps,
        );
    };

export default createFabric;
